export default __webpack_public_path__ + "static/media/content.22769ea5.png";